import { Component, Optional } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-exampleplan',
    templateUrl: './dialog-exampleplan.component.html',
    styleUrls: ['./dialog-exampleplan.component.css'],
    standalone: false
})
export class DialogExamplePlanComponent {
  constructor(@Optional() public dialogRef: MatDialogRef<DialogExamplePlanComponent>) {}

  closeDialog() {
    this.dialogRef.close();
  }

}
